var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-404"},[_c('div',{staticClass:"error-404__text"},[_c('h1',[_vm._v("Welp!, nothing to do here...")]),_c('p',[_vm._v(" Got yourself in the wrong page? You can return to our "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("homepage")]),_vm._v(" or try again later. ")],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }